module.exports = __webpack_public_path__ + "static/media/woo17.6e619cf4.png";